export const SCHEDULE_LIST_TITLE = '未計画工程一覧'
